import React from 'react'
import { observer } from 'mobx-react'
import YAxisTick from './YAxisTick'

const YAxis = ({ yScale, yTickCount, width, height }) => {
  let ticks = yScale.ticks(yTickCount)
  if (ticks.length === 0) {
    ticks = [0]
  }

  return (
    <g>
      {
        ticks.map(tick => (
          <YAxisTick
            key={tick}
            tick={tick}
            yScale={yScale}
            width={width}
            height={height}
          />
        ))
      }
    </g>
  )
}

export default observer(YAxis)
